<template>
    <v-card>
        <v-data-table
            :headers="historyTable.headers"
            :items="historyTable.items"
            :loading="loading"
            :height="windowSize.y + 455"
            :items-per-page="-1"
            fixed-header
            :row-props="getRowClassName"
        >
            <!-- vuetify hide footer--->
            <template #bottom></template>
        </v-data-table>

        <v-row class="quantity outline-text">
            <v-col
                >Total Labor Qty: {{ totalLaborQty().toFixed(2) }} | Total Scrap Qty:
                {{ totalScrapQty() }}
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import axios from "axios";

export default {
    name: "LaborHistory",
    props: {
        jobInfo: {
            type: Object,
            default: null,
        },
        machine_id: {
            type: String,
            default: null,
        },
    },
    watch:{
        machine_id: {
            handler(val) {

            },

            deep: true,
            immediate: true,
        },
    },
    data() {
        return {
            historyTable: {
                headers: [
                    { title: "Date", key: "ClockInDate", align:'center' },
                    { title: "Start", key: "DspClockInTime", align:'center' },
                    { title: "End", key: "DspClockOutTime", align:'center' },
                    { title: "Name", key: "Name", align:'center' },
                    { title: "Labor Qty", key: "Qty", align:'center' },
                    { title: "Scrap	", key: "ScrapQty", align:'center' },
                    { title: "Labor Hrs", key: "LaborHrs", align:'center' },
                    { title: "Resource ID", key: "ResourceID", align:'center' },
                ],
                items: [],
            },
            loading: false,
            bodyTextDirection: "center",
            windowSize: {
                x: 0,
                y: 0,
            },
        };
    },
    mounted() {
        this.getHistory();
    },
    methods: {
        async getHistory() {
            this.loading = true;
            try {
                await axios
                    .get(
                        route("legacy-api.getLaborHistory", {
                            JobNum: this.jobInfo.JobNum,
                            AsmSeq: this.jobInfo.AsmSeq,
                            OprSeq: this.jobInfo.OprSeq,
                        })
                    )
                    .then((response) => {
                        this.historyTable.items = response.data;
                    });
            } catch (err) {
                console.log(err);
            }
            this.loading = false;
        },
        getRowClassName(item) {
            if (item.item.ActiveTrans === 1) {
                //return "active-row";
                return { style: { backgroundColor: "lightgreen" } };
            }
        },
        totalLaborQty() {

           //ResourceID
            let sum = 0;
            this.historyTable.items.forEach(ele =>{
                    sum += Number(ele.Qty)
            })
            return sum;
        },
        totalScrapQty() {
            let sum = 0;
            return this.historyTable.items.reduce(
                (total, item) => total + item.ScrapQty,
                0
            );
        },
    },
};
</script>

<style scoped>


:deep(.active-row) {
    --easy-table-body-row-background-color: lightgreen !important;
}

.quantity {
    background-color: #007bff;
    text-align: center;
    padding: 2px;
}

.outline-text {
    color: white;
    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
        1px 1px 0 #000;
}
</style>
